// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const FOOD_TRACEABILITY_WORDS = {
    // ── Generic values ──────────────────────────────────────────
    none: { en: '—', vi: '—' },
    yes: { en: 'Yes', vi: 'Có' },
    no: { en: 'No', vi: 'Không' },
    notStated: { en: 'Not stated', vi: 'Chưa nêu' },
    notRecorded: { en: 'Not recorded', vi: 'Chưa ghi nhận' },
    referenceNotFound: { en: 'No longer found', vi: 'Không còn tìm thấy' },
    evidenceFiles: { en: 'Evidence files', vi: 'Tệp tài liệu chứng minh' },
    evidenceFilesNone: { en: 'No file bound', vi: 'Chưa gắn tệp nào' },
    evidenceFileNotHeld: { en: 'File no longer held', vi: 'Tệp không còn được lưu giữ' },
    labelNotReadable: { en: 'Label could not be read', vi: 'Không đọc được nhãn' },
    linkWithheld: {
        en: 'Linked record (name not shown: you do not hold the read permission of its register)',
        vi: 'Hồ sơ được liên kết (không hiển thị tên: bạn không có quyền xem sổ chứa hồ sơ này)',
    },
    // ── Register notices ────────────────────────────────────────
    registerNotDeclared: {
        en: 'No installed framework declares this register, so no record can be created. This describes the content installed for your organization, not whether your organization holds the duty.',
        vi: 'Không có khung tuân thủ đã cài đặt nào khai báo sổ này nên không thể tạo hồ sơ. Câu này mô tả nội dung đã cài đặt cho tổ chức bạn, không phải việc tổ chức bạn có nghĩa vụ hay không.',
    },
    notYetInForce: { en: 'Not yet in force', vi: 'Chưa có hiệu lực' },
    frameworkAppliesFrom: {
        en: 'The installed framework applies from {date}.',
        vi: 'Khung tuân thủ đã cài đặt được áp dụng từ {date}.',
    },
    // E12.5 — a food grant is a per-person grant an approver lends until an end date (a
    // delegation), not a role. The key keeps its name for the pages that read it.
    accessByRole: {
        en: 'Access to these registers is granted to each person: an approver lends the food permissions they hold until an end date, and the grant lapses on that date or when it is removed. No lot- or supplier-level restriction is applied.',
        vi: 'Quyền truy cập các sổ này được cấp cho từng người: người phê duyệt ủy quyền các quyền thực phẩm mà chính họ nắm giữ đến một ngày kết thúc, và quyền được cấp hết hiệu lực vào ngày đó hoặc khi bị thu hồi. Không áp dụng giới hạn theo từng lô hay từng nhà cung cấp.',
    },
    // ── Facts (AC1, AC2) ────────────────────────────────────────
    factMissing: { en: 'Missing', vi: 'Còn thiếu' },
    factEntered: { en: 'Entered', vi: 'Đã nhập' },
    registrationReferenceUnverified: {
        en: 'Unverified — entered by a person; the platform does not check it',
        vi: 'Chưa xác minh — do một người nhập; nền tảng không kiểm tra',
    },
    // ── Approvals ───────────────────────────────────────────────
    awaitingApproval: { en: 'Awaiting approval', vi: 'Chờ phê duyệt' },
    approved: { en: 'Approved', vi: 'Đã phê duyệt' },
    personsJudgement: {
        en: 'A person’s judgement, approved by a second person',
        vi: 'Nhận định của một người, được người thứ hai phê duyệt',
    },
    // ── Certificates (AC3–AC5, AC7) ─────────────────────────────
    certificateHeld: { en: 'Held', vi: 'Đang nắm giữ' },
    certificateSuspended: { en: 'Suspended', vi: 'Bị đình chỉ' },
    certificateWithdrawn: { en: 'Withdrawn', vi: 'Bị thu hồi' },
    lapseWindowNotSet: { en: 'Window not set', vi: 'Chưa thiết lập khoảng thời gian cảnh báo' },
    lapsing: { en: 'Lapsing', vi: 'Sắp hết hạn' },
    notLapsing: { en: 'Not lapsing', vi: 'Chưa đến khoảng cảnh báo' },
    pastValidityEnd: { en: 'Past its validity end', vi: 'Đã qua ngày hết hiệu lực' },
    // ── Lot results, inspections, warnings (AC8–AC11) ───────────
    inputLinkMissing: { en: 'Input lot link missing', vi: 'Chưa có liên kết lô đầu vào' },
    resultAsRecorded: {
        en: 'Result as recorded — the platform makes no finding on it',
        vi: 'Kết quả như đã ghi nhận — nền tảng không đưa ra kết luận',
    },
    testingBodyStatementOwn: {
        en: 'The establishment’s own statement, not checked by the platform',
        vi: 'Khai báo của chính cơ sở, nền tảng không kiểm tra',
    },
    responseOutstanding: { en: 'Response outstanding', vi: 'Chưa có phản hồi' },
    responseAwaitingApproval: {
        en: 'Response awaiting approval',
        vi: 'Phản hồi đang chờ phê duyệt',
    },
    responseApproved: { en: 'Response approved', vi: 'Phản hồi đã được phê duyệt' },
    warningSourceStateNotice: { en: 'State notice', vi: 'Thông báo của cơ quan nhà nước' },
    warningSourceSelfDetection: { en: 'Self-detection', vi: 'Tự phát hiện' },
    warningSourceOther: { en: 'Other', vi: 'Khác' },
    sourceChecked: { en: 'Source checked by a person', vi: 'Nguồn đã được một người kiểm tra' },
    sourceNotChecked: { en: 'Source not checked', vi: 'Nguồn chưa được kiểm tra' },
    // ── Notices and decisions (AC14–AC16) ───────────────────────
    noticeDraft: { en: 'Not sent', vi: 'Chưa gửi' },
    noticeSent: { en: 'Sent (proof attached)', vi: 'Đã gửi (có tài liệu chứng minh)' },
    figuresNotBothRecorded: {
        en: 'Only one figure recorded',
        vi: 'Mới ghi nhận một số liệu',
    },
    figuresAgree: { en: 'The two figures agree', vi: 'Hai số liệu khớp nhau' },
    figuresDiffer: {
        en: 'The two figures differ — shown as reported, not resolved',
        vi: 'Hai số liệu khác nhau — hiển thị như đã báo cáo, không tự điều chỉnh',
    },
    unitsDiffer: {
        en: 'The two figures are in different units and are not converted',
        vi: 'Hai số liệu khác đơn vị tính và không được quy đổi',
    },
    figureDistributorSold: { en: 'Recipient’s sold quantity', vi: 'Số lượng bên nhận đã bán' },
    figureDistributorStock: { en: 'Recipient’s stock quantity', vi: 'Số lượng bên nhận còn tồn' },
    figureTraderStock: { en: 'Our own figure', vi: 'Số liệu của chính tổ chức' },
    noticeKindDownstreamRecipient: {
        en: 'To a party that received the lot',
        vi: 'Gửi bên đã nhận lô hàng',
    },
    noticeKindUpstreamSupplier: {
        en: 'To a supplier of inputs or packaging',
        vi: 'Gửi nhà cung cấp nguyên liệu hoặc bao bì',
    },
    noticeKindProducerOrSupplyingDistributor: {
        en: 'To the producer or the distributor that supplied the lot',
        vi: 'Gửi nhà sản xuất hoặc nhà phân phối đã cung cấp lô hàng',
    },
    noticeKindOther: { en: 'Other', vi: 'Khác' },
    ownReportSent: {
        en: 'Report sent by the establishment, as recorded — the platform sends nothing',
        vi: 'Báo cáo do cơ sở gửi, như đã ghi nhận — nền tảng không gửi',
    },
    resultObtainedByExternal: { en: 'Obtained by an outside party', vi: 'Do bên ngoài thực hiện' },
    resultSuperseded: {
        en: 'Replaced by a later entry — kept readable',
        vi: 'Đã được thay bằng bản ghi sau — vẫn giữ để tra cứu',
    },
    priorValues: { en: 'Prior values', vi: 'Giá trị trước đây' },
    decisionDocumentMissing: {
        en: 'Decision document missing — not counted as recorded',
        vi: 'Chưa có văn bản quyết định — chưa được tính là đã ghi nhận',
    },
    decisionRecorded: {
        en: 'Recorded (decision document attached)',
        vi: 'Đã ghi nhận (có văn bản quyết định)',
    },
    asStatedInDecision: {
        en: 'As the decision states it',
        vi: 'Theo nội dung quyết định',
    },
    // E12.5 P3-7 (R-46) — `{form}` is the form's own designation read from the installed
    // pack (`FoodTraceabilityContext.report_designation`), else `reportDesignationFallback`.
    reportCopyNotice: {
        en: 'Internal copy of the {form} layout, not the report as filed',
        vi: 'Bản sao nội bộ theo mẫu {form}, không phải báo cáo đã nộp',
    },
    reportDesignationFallback: { en: 'report', vi: 'báo cáo' },
    // Gate E12.5 pass 1 (P3, compliance) — states only what the installed pack does
    // (it declares no recipient statement for the layout); it no longer asserts that a
    // recipient and channel are "not designated", a regulatory position no pack made.
    recipientStatementNotDeclared: {
        en: 'No recipient statement is declared for this layout',
        vi: 'Mẫu báo cáo đã cài đặt không khai báo nội dung về bên nhận',
    },
    // ── Corrections, suppliers, retention, routes (AC18–AC22) ───
    correctionAwaitingApproval: {
        en: 'Correction awaiting a second person’s approval',
        vi: 'Hiệu chỉnh đang chờ người thứ hai phê duyệt',
    },
    correctionApplied: { en: 'Correction applied', vi: 'Đã áp dụng hiệu chỉnh' },
    correctionRejected: { en: 'Correction rejected', vi: 'Hiệu chỉnh bị từ chối' },
    supplierCorrectionOutstanding: { en: 'Outstanding', vi: 'Chưa có phản hồi' },
    supplierCorrectionReplied: { en: 'Replied', vi: 'Đã phản hồi' },
    suppliersCorrection: {
        en: 'The supplier’s correction, as the supplier provided it',
        vi: 'Hiệu chỉnh của nhà cung cấp, như nhà cung cấp đã cung cấp',
    },
    retentionAnchorNotRecorded: {
        en: 'The date the period runs from is not recorded on this lot',
        vi: 'Lô này chưa ghi nhận ngày làm mốc tính thời hạn',
    },
    retentionPeriodNotDeclared: {
        en: 'No installed period applies',
        vi: 'Không có thời hạn đã cài đặt nào áp dụng',
    },
    receiptAsReturned: {
        en: 'Reference as returned by the other system, not issued by the platform',
        vi: 'Số tham chiếu do hệ thống bên kia trả về, không do nền tảng cấp',
    },
    genericConnectorRun: { en: 'Generic connector run', vi: 'Lần chạy trình kết nối chung' },
    // ── Grants and complaints (AC23–AC27) ───────────────────────
    grantApplied: { en: 'Applied', vi: 'Đã áp dụng' },
    grantRemovalOutstanding: { en: 'Removal outstanding', vi: 'Chưa thu hồi' },
    grantRemoved: { en: 'Removed', vi: 'Đã thu hồi' },
    reviewKeep: { en: 'Keep', vi: 'Giữ nguyên' },
    reviewChange: { en: 'Change', vi: 'Thay đổi' },
    reviewRemove: { en: 'Remove', vi: 'Thu hồi' },
    investigationNotDecided: { en: 'Not decided', vi: 'Chưa quyết định' },
    investigate: { en: 'To be investigated', vi: 'Sẽ điều tra' },
    notInvestigated: { en: 'Not investigated', vi: 'Không điều tra' },
    complaintOpen: { en: 'Open', vi: 'Đang mở' },
    complaintClosed: { en: 'Closed', vi: 'Đã đóng' },
    lotNotIdentified: { en: 'Lot not identified', vi: 'Không xác định được lô' },
    retentionBasisNotDeclared: {
        en: 'Retention basis not declared',
        vi: 'Chưa khai báo căn cứ lưu giữ',
    },
    internalRecord: { en: 'Internal record', vi: 'Hồ sơ nội bộ' },
    // ── Correction impact on past reports (Sprint 62.49.2, AC5/AC6) ──
    // Link, not decide: these words mark what a report carried and what a person determined.
    // None of them says a notice must be sent or is owed by the platform's reading.
    carriedBeforeCorrection: {
        en: 'Carried the value before the correction',
        vi: 'Đã nêu giá trị trước khi hiệu chỉnh',
    },
    determinationNotRecorded: {
        en: 'No determination recorded',
        vi: 'Chưa ghi nhận kết quả xác định',
    },
    correctiveNoticeOwed: {
        en: 'Corrective notice owed (the establishment’s determination)',
        vi: 'Cần thông báo hiệu chỉnh (theo kết quả xác định của cơ sở)',
    },
    noCorrectiveNoticeOwed: {
        en: 'No corrective notice owed (the establishment’s determination)',
        vi: 'Không cần thông báo hiệu chỉnh (theo kết quả xác định của cơ sở)',
    },
    answerNotSubmitted: { en: 'Answer not submitted', vi: 'Chưa nộp phản hồi' },
    // ── Records-request clock (AC28) ────────────────────────────
    receiptNotRecorded: {
        en: 'Receipt time not recorded — the clock is shown undated',
        vi: 'Chưa ghi nhận thời điểm nhận — thời hạn hiển thị không kèm ngày',
    },
};
/** The word for `key` in `locale` (VI for `vi` / `vi-*`, else EN), `{name}` filled from `values`. */
export function foodTraceabilityWord(key, locale, values = {}) {
    const pair = FOOD_TRACEABILITY_WORDS[key];
    const text = locale === 'vi' || locale.startsWith('vi-') ? pair.vi : pair.en;
    return text.replace(/\{(\w+)\}/g, (whole, name) => values[name] ?? whole);
}
//# sourceMappingURL=food-traceability-words.js.map